export const CATALOGUE_LABEL = {
  en: "Download Catalogue",
  kn: "ಕ್ಯಾಟಲಾಗ್ ಡೌನ್‌ಲೋಡ್",
  hi: "कैटलॉग डाउनलोड करें",
};

export const PRODUCT_I18N = {
  kn: {
    "adjustable-props": {
      desc: "32 NB ಪೈಪ್‌ನಿಂದ ತಯಾರಿಸಿದ ಹೆವಿ-ಡ್ಯೂಟಿ ಸ್ಟೀಲ್ ಪ್ರಾಪ್‌ಗಳು — ಪ್ರತಿ ಪೋರ್‌ನಲ್ಲೂ ಸ್ಲ್ಯಾಬ್ ಮತ್ತು ಬೀಮ್ ಹೊರೆಗಳನ್ನು ಹೊರುತ್ತವೆ. ರೋಲ್ಡ್ ಸೆಲ್ಫ್-ಕ್ಲೀನಿಂಗ್ ಥ್ರೆಡ್‌ಗಳು ಎತ್ತರ ಹೊಂದಿಸುವಿಕೆಯನ್ನು ವೇಗವಾಗಿಸುತ್ತವೆ.",
      features: [
        "32 NB ಹೆವಿ-ಡ್ಯೂಟಿ ಸ್ಟೀಲ್ ಟ್ಯೂಬ್ ರಚನೆ",
        "1800 mm ರಿಂದ 5500 mm ವರೆಗೆ ಎತ್ತರ ಹೊಂದಿಸಬಹುದು",
        "ವೇಗದ ಸೆಟ್ಟಿಂಗ್‌ಗಾಗಿ ಸೆಲ್ಫ್-ಕ್ಲೀನಿಂಗ್ ಥ್ರೆಡ್‌ಗಳು",
        "ದೀರ್ಘ ಸೈಟ್ ಬಳಕೆಗೆ ಪೌಡರ್-ಕೋಟెಡ್ ಫಿನಿಶ್",
      ],
    },
    "adjustable-spans": {
      desc: "ಟಿಮ್ಬರ್ ರನ್ನರ್‌ಗಳನ್ನು ಸಂಪೂರ್ಣ ಬದಲಾಯಿಸುವ ಟೆಲಿಸ್ಕೋಪಿಕ್ ಅಡ್ಜಸ್ಟಬಲ್ ಸ್ಪಾನ್‌ಗಳು — ಸೆಕೆಂಡುಗಳಲ್ಲಿ ಸರಿಯಾದ ಅಗಲ ಹೊಂದಿಸಿ, ಬಾರಿಗೆ ಬಾರಿ ಮರುಬಳಸಿ.",
      features: [
        "ಟೆಲಿಸ್ಕೋಪಿಕ್ ಒಳ–ಹೊರ ಸ್ಟೀಲ್ ಭಾಗಗಳು",
        "1200 mm ರಿಂದ 2600 mm ವರೆಗೆ ಉದ್ದ",
        "ಟಿಮ್ಬರ್ ರನ್ನರ್ ಮತ್ತು ಕಾರ್ಪೆಂಟರಿ ಸಮಯದ ಅಗತ್ಯವಿಲ್ಲ",
        "ಸಮತಲ ಸ್ಲ್ಯಾಬ್ ಲೆವಲ್‌ಗೆ ಹೆಚ್ಚಿನ ಗಟ್ಟಿತನ",
      ],
    },
    "h-frame-scaffolding": {
      desc: "ವೇಗವಾಗಿ ಜೋಡಿಸಬಹುದಾದ ಗಟ್ಟಿ ವೆಲ್ಡೆಡ್ ಎಚ್ ಫ್ರೇಮ್‌ಗಳು — ಗೋಡೆ, ಪ್ಲಾಸ್ಟರ್, ಮುಖಭಾಗ ಮತ್ತು ಸ್ಲ್ಯಾಬ್ ಕೆಲಸಕ್ಕೆ ಅತ್ಯಂತ ಸಾಮರ್ಥ್ಯದ ವ್ಯವಸ್ಥೆ.",
      features: [
        "1700 mm ಮತ್ತು 2000 mm ಎತ್ತರದ ಫ್ರೇಮ್‌ಗಳು",
        "ಕ್ರಾಸ್ ಬ್ರೇಸ್ ಮತ್ತು ಜॉइಂಟ್ ಪಿನ್‌ಗಳೊಂದಿಗೆ ವೇಗದ ಸ್ಟ್ಯಾಕಿಂಗ್",
        "ಸುರಕ್ಷಿತ, ಸಮತಲ ವರ್ಕಿಂಗ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳು",
        "ಬೇಸ್ ಜ್ಯಾಕ್ ಮತ್ತು ವಾಕ್‌ವೇ ಜಾಲಿಯೊಂದಿಗೆ ಹೊಂದಾಣಿಕೆ",
      ],
    },
    "cuplock-system": {
      desc: "ಭಾರೀ ಫಾಲ್ಸ್‌ವರ್ಕ್ ಮತ್ತು ಆಕ್ಸಸ್‌ಗಾಗಿ ಸಾಬೀತಾದ ಮಾಡ್ಯುಲರ್ ವ್ಯವಸ್ಥೆ. ಒಂದೇ ಹ್ಯಾಮರ್ ಬಡಿತದಲ್ಲಿ ನಾಲ್ಕು ಲೆಡ್ಜರ್‌ಗಳು ಲಾಕ್ — ಸಡಿಲವಾದ ನಟ್-ಬೋಲ್ಟ್‌ಗಳಿಲ್ಲ.",
      features: [
        "ಒಂದೇ ಬಡಿತದಲ್ಲಿ ನೋಡ್ ಲಾಕಿಂಗ್",
        "ಸಡಿಲವಾದ ನಟ್-ಬೋಲ್ಟ್‌ಗಳಿಲ್ಲ",
        "ಭಾರೀ ಫಾಲ್ಸ್‌ವರ್ಕ್‌ಗೆ ಹೆಚ್ಚಿನ ಲೋಡ್ ಸಾಮರ್ಥ್ಯ",
        "ಗ್ಯಾಲ್ವನೈಸ್ಡ್ / ಪೇಂಟೆಡ್ ಆಯ್ಕೆಗಳು",
      ],
    },
    "walkway-jali": {
      desc: "ಲೆಡ್ಜರ್ ಟ್ಯೂಬ್‌ಗಳ ಮೇಲೆ ಭದ್ರವಾಗಿ ಕೂರುವ ಹುಕ್ ಎಂಡ್ ಹೊಂದಿರುವ ಆಂಟಿ-ಸ್ಕಿಡ್ ಸ್ಟೀಲ್ ವಾಕ್‌ವೇ ಪ್ಲಾಂಕ್‌ಗಳು — ಯಾವುದೇ ಎತ್ತರದಲ್ಲೂ ವಿಶ್ವಾಸದ ಹೆಜ್ಜೆ.",
      features: [
        "ಆಂಟಿ-ಸ್ಕಿಡ್ ಪರ್ಫೊರೇಟెಡ್ ಸ್ಟೀಲ್ ಮೇಲ್ಮೈ",
        "210–400 mm ಅಗಲ, 38 mm ಎತ್ತರ",
        "ಲೆಡ್ಜರ್‌ಗಳಿಗೆ ಲಾಕ್ ಆಗುವ ಹುಕ್ ಎಂಡ್‌ಗಳು",
        "ಟಿಮ್ಬರ್ ಪ್ಲಾಂಕ್‌ಗಿಂತ ಹೆಚ್ಚು ಬಾಳಿಕೆ",
      ],
    },
    "centring-sheets": {
      desc: "ಡెಕ್ ಫಾರ್ಮ್‌ವರ್ಕ್‌ಗಾಗಿ ಗಟ್ಟಿ ಅಂಚುಗಳೊಂದಿಗೆ ಪ್ರೆಸ್ಡ್ ಸ್ಟೀಲ್ ಸೆಂಟರಿಂಗ್ ಶೀಟ್‌ಗಳು — ಪ್ರತಿ ಪೋರ್‌ನಲ್ಲೂ ಸಮತಟ್ಟಾದ, ಸ್ವಚ್ಛ ಮೇಲ್ಮೈ.",
      features: [
        "ದಪ್ಪನ ಆಯ್ಕೆಗಳು: 1.2 / 1.6 / 2.0 / 2.5 mm",
        "ಬಾಗುವಿಕೆ ತಡೆಯುವ ಗಟ್ಟಿ ಪ್ರೆಸ್ಡ್ ಅಂಚುಗಳು",
        "ಸ್ವಚ್ಛ ಫಿನಿಶ್‌ಗೆ ಮೃದು ಮೇಲ್ಮೈ",
        "ಬೇಕಾದರೆ ಕಸ್ಟಮ್ ಗಾತ್ರಗಳು",
      ],
    },
    "adjustable-base-jack": {
      desc: "ಅಸಮಾನ ನೆಲವನ್ನು ಸರಿಪಡಿಸಿ ನಿಮ್ಮ ಸ್ಕ್ಯಾಫೋಲ್ಡ್ ಅನ್ನು ನಿಖರವಾಗಿ ನಿಲ್ಲಿಸುವ ಅಡ್ಜಸ್ಟಬಲ್ ಬೇಸ್ ಜ್ಯಾಕ್‌ಗಳು.",
      features: [
        "38 mm ಸಾಲಿಡ್ / ಹಾಲೊ ಥ್ರೆಡೆಡ್ ಸ್ಟೆಮ್",
        "600 mm ವರೆಗೆ ಎತ್ತರ ಹೊಂದಾಣಿಕೆ",
        "150 × 150 mm ಸ್ಟೀಲ್ ಬೇಸ್ ಪ್ಲೇಟ್",
        "ಕಪ್‌ಲಾಕ್, ಎಚ್-ಫ್ರೇಮ್ ಮತ್ತು ಟ್ಯೂಬ್ ವ್ಯವಸ್ಥೆಗೆ ಹೊಂದುತ್ತದೆ",
      ],
    },
    "adjustable-u-head-jack": {
      desc: "ಫಾಲ್ಸ್‌ವರ್ಕ್ ಮೇಲ್ಭಾಗದಲ್ಲಿ ಬೀಮ್‌ಗಳನ್ನು ಭದ್ರವಾಗಿ ಹಿಡಿಯುವ ಯು ಹೆಡ್ ಜ್ಯಾಕ್‌ಗಳು — ನಿಖರ ಲೆवಲ್‌ಗೆ ಸೂಕ್ಷ್ಮ ಎತ್ತರ ಹೊಂದಾಣಿಕೆ.",
      features: [
        "ಬೀಮ್‌ಗಳಿಗೆ ಯು-ಹೆಡ್ ಕ್ರೇಡಲ್",
        "38 mm ಸಾಲಿಡ್ / ಹಾಲೊ ಥ್ರೆಡೆಡ್ ಸ್ಟೆಮ್",
        "600 mm ವರೆಗೆ ಸೂಕ್ಷ್ಮ ಎತ್ತರ ಹೊಂದಾಣಿಕೆ",
        "ಪ್ರಾಪ್ಸ್, ಕಪ್‌ಲಾಕ್ ಮತ್ತು ಫ್ರೇಮ್‌ಗಳೊಂದಿಗೆ ಜೋಡಣೆ",
      ],
    },
    "customised-scaffolding": {
      desc: "ವಿಶಿಷ್ಟ ಎತ್ತರ, ಅಸಾಮಾನ್ಯ ಅಗಲ, ವಿಶೇಷ ಲೋಡ್ — ನಮ್ಮ ಬೆಂಗಳೂರು ಘಟಕ ನಿಮ್ಮ ಡ್ರಾಯಿಂಗ್‌ಗೆ ತಕ್ಕಂತೆ ಕ್ಯಾಟలಾಗ್ ಗುಣಮಟ್ಟದಲ್ಲಿ ತಯಾರಿಸುತ್ತದೆ.",
      features: [
        "ನಿಮ್ಮ ಡ್ರಾಯಿಂಗ್ ಮತ್ತು ಸೈಟ್ ಅಗತ್ಯಕ್ಕೆ ತಯಾರಿಕೆ",
        "ಪ್ರಾಪ್ಸ್, ಫ್ರೇಮ್ ಮತ್ತು ಜ್ಯಾಕ್‌ಗಳಲ್ಲಿ ಕಸ್ಟಮ್ ಗಾತ್ರ",
        "ಇನ್-ಹೌಸ್ ವೆల್ಡಿಂಗ್, ಪ್ರೆಸ್ಸಿಂಗ್ ಮತ್ತು ಫಿನಿಶಿಂಗ್",
        "ಸ್ಥಿರ QC ಯೊಂದಿಗೆ ಬ್ಯಾಚ್ ಆರ್ಡರ್‌ಗಳು",
      ],
    },
  },
  hi: {
    "adjustable-props": {
      desc: "32 NB पाइप से बने हेवी-ड्यूटी स्टील प्रॉप्स — हर पोर में स्लैब और बीम का भार संभालते हैं। रोल्ड सेल्फ-क्लीनिंग थ्रेड से ऊँचाई तुरंत सेट होती है।",
      features: [
        "32 NB हेवी-ड्यूटी स्टील ट्यूब",
        "1800 mm से 5500 mm तक समायोज्य ऊँचाई",
        "तेज़ सेटिंग के लिए सेल्फ-क्लीनिंग थ्रेड",
        "लंबी साइट-लाइफ़ के लिए पाउडर-कोटेड फ़िनिश",
      ],
    },
    "adjustable-spans": {
      desc: "टेलीस्कोपिक एडजस्टेबल स्पैन जो लकड़ी के रनर की जगह लेते हैं — सेकंडों में सही चौड़ाई सेट करें और हर पोर में दोबारा इस्तेमाल करें।",
      features: [
        "टेलीस्कोपिक इनर-आउटर स्टील सेक्शन",
        "1200 mm से 2600 mm तक लंबाई",
        "लकड़ी के रनर और कारपेंटरी का समय बचत",
        "समान स्लैब लेवल के लिए अधिक मज़बूती",
      ],
    },
    "h-frame-scaffolding": {
      desc: "जल्दी जुड़ने वाले मज़बूत वेल्डेड एच फ्रेम — चिनाई, प्लास्टर, फ़साद और स्लैब काम के लिए सबसे किफ़ायती सिस्टम।",
      features: [
        "1700 mm और 2000 mm ऊँचाई के फ्रेम",
        "क्रॉस ब्रेस और जॉइंट पिन से तेज़ स्टैकिंग",
        "सुरक्षित, समतल वर्किंग प्लेटफ़ॉर्म",
        "बेस जैक और वॉकवे जाली के साथ कम्पैटिबल",
      ],
    },
    "cuplock-system": {
      desc: "भारी फ़ॉल्सवर्क और एक्सेस के लिए आज़माया हुआ मॉड्यूलर सिस्टम। एक हथौड़े की चोट से चार लेजर लॉक — कोई नट-बोल्ट नहीं।",
      features: [
        "एक चोट में नोड लॉकिंग",
        "कोई ढीले नट-बोल्ट नहीं",
        "भारी फ़ॉल्सवर्क के लिए हाई लोड क्षमता",
        "गैल्वनाइज़्ड / पेंटेड विकल्प",
      ],
    },
    "walkway-jali": {
      desc: "लेजर ट्यूब पर मज़बूती से बैठने वाले हुक-एंड वाले एंटी-स्किड स्टील वॉकवे प्लैंक — हर ऊँचाई पर भरोसेमंद क़दम।",
      features: [
        "एंटी-स्किड परफोरेटेड स्टील सतह",
        "210–400 mm चौड़ाई, 38 mm ऊँचाई",
        "लेजर पर लॉक होने वाले हुक-एंड",
        "लकड़ी के प्लैंक से कहीं अधिक लंबी लाइफ़",
      ],
    },
    "centring-sheets": {
      desc: "डेक फ़ॉर्मवर्क के लिए स्टिफ़न एज वाली प्रेस्ड स्टील सेंटरिंग शीट — हर पोर में सपाट, साफ़ सॉफ़िट।",
      features: [
        "मोटाई: 1.2 / 1.6 / 2.0 / 2.5 mm",
        "वार्पिंग रोकने वाले स्टिफ़ प्रेस्ड एज",
        "साफ़ फ़िनिश के लिए स्मूद सतह",
        "माँग पर कस्टम साइज़",
      ],
    },
    "adjustable-base-jack": {
      desc: "असमान ज़मीन को संभालकर आपके स्कैफ़ोल्ड को बिल्कुल सीधा रखने वाले एडजस्टेबल बेस जैक।",
      features: [
        "38 mm सॉलिड / हॉलो थ्रेडेड स्टेम",
        "600 mm तक ऊँचाई समायोजन",
        "150 × 150 mm स्टील बेस प्लेट",
        "कपलॉक, एच-फ्रेम और ट्यूब सिस्टम में फ़िट",
      ],
    },
    "adjustable-u-head-jack": {
      desc: "फ़ॉल्सवर्क के ऊपर बीम को मज़बूती से थामने वाले यू हेड जैक — सटीक लेवल के लिए फ़ाइन एडजस्टमेंट।",
      features: [
        "बीम और चैनल के लिए यू-हेड क्रेडल",
        "38 mm सॉलिड / हॉलो थ्रेडेड स्टेम",
        "600 mm तक फ़ाइन ऊँचाई समायोजन",
        "प्रॉप्स, कपलॉक और फ्रेम के साथ जोड़",
      ],
    },
    "customised-scaffolding": {
      desc: "खास ऊँचाई, असाधारण चौड़ाई, विशेष लोड — हमारी बेंगलुरु यूनिट आपकी ड्रॉइंग के मुताबिक़ कैटलॉग-क्वालिटी में बनाती है।",
      features: [
        "आपकी ड्रॉइंग और साइट ज़रूरत के अनुसार निर्माण",
        "प्रॉप्स, फ्रेम और जैक में कस्टम साइज़",
        "इन-हाउस वेल्डिंग, प्रेसिंग, फिनिशिंग",
        "समान QC के साथ बैच ऑर्डर",
      ],
    },
  },
};
